module.exports = __webpack_public_path__ + "static/img/password.9173da92.svg";